<template>
  <div class="dropdown-container">
    <show-at breakpoint="small">
      <img class="menu-icon" src="~@/assets/icn-user.svg" />
    </show-at>
    <show-at breakpoint="mediumAndAbove">
      <div>{{ this.userName }}<dropdown-arrow /></div>
    </show-at>

    <ul class="dropdown">
      <li>
        <x-button class="profile-link full-width" :to="{ name: 'user-infos' }">
          <ic-profile />
          {{ $t('common.my-profile') }}
        </x-button>
      </li>

      <li v-if="$featureFlag('cAssistanceUrl') && !isEsrSsoRestriction">
        <x-button
          class="assistance-button full-width"
          :href="$featureValue('cAssistanceUrl')"
          target="_blank"
        >
          <ic-help />
          {{ $t('common.assistance') }}
        </x-button>
      </li>

      <li v-if="!isEsrSsoRestriction">
        <x-button
          class="contractual-documents-button full-width" 
          :href="siteUrlLandingPage"
          target='_blank'
        >
          <ic-download />
          {{ $t('common.contractual-documents') }}
        </x-button>
      </li>

      <li>
        <x-button class="private-button full-width" @click="switchPrivateMode">
          <ic-private />
          <span
            class="private-mode"
            v-html="$t(`common.private-mode.${privateMode ? 'on' : 'off'}`)"
          />
        </x-button>
      </li>

      <li v-if="!isAdvisor">
        <logout-user />
      </li>

      <li v-if="!isAdvisor">
        <div class="last-connection">
          <p>{{ $t('common.last-connection') }}</p>
          <p>{{ lastConnection }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
import dropdownArrow from '@/svg/dropdown-arrow'
import logoutUser from '@/components/logout-button'
import dateFns from 'date-fns'
import frLocale from 'date-fns/locale/fr'
import { showAt } from 'vue-breakpoints'
import icHelp from '@/svg/ic-help'
import icProfile from '@/svg/ic-profile'
import icPrivate from '@/svg/ic-private'
import icDownload from '@/svg/ic-download'

export default {
  name: 'UserDropdownMenu',

  components: {
    dropdownArrow,
    logoutUser,
    showAt,
    icHelp,
    icProfile,
    icPrivate,
    icDownload
  },

  computed: {
    ...mapGetters({
      userName: 'user/userName',
      isAdvisor: 'auth/isAdvisor',
      isEsrSsoRestriction: 'isEsrSsoRestriction'
    }),
    ...mapState({
      brandname: 'brandname',
      privateMode: 'privateMode'
    }),
    lastConnection() {
      return dateFns.format(new Date(), 'DD MMM YYYY - HH[h]mm', {
        locale: frLocale
      })
    },
    siteUrlLandingPage() {
      return `${process.env.SITE_URL_LANDING_PAGE}/documents`
    }
  },

  methods: {
    ...mapMutations({
      switchPrivateMode: 'switchPrivateMode'
    })
  }
}
</script>

<style lang="scss" scoped rel="stylesheet/scss">
@import '~@/styles/vars.scss';

.dropdown-container {
  position: relative;

  > div {
    cursor: pointer;

    svg {
      width: 1rem;
      margin-left: $space-small;
    }
  }

  &:hover .dropdown {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
    transition: transform 300ms $extra-ease-out, opacity 300ms $extra-ease-out,
      visibility 0ms;
  }
}

.dropdown {
  min-width: 23rem;
  background-color: white;
  color: $color-daddy;
  position: absolute;
  top: 120%;
  right: -1.8rem;
  border-radius: 4px;
  padding: $space-medium 0;
  box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.2);
  visibility: hidden;
  opacity: 0;
  transform: translateY(20px);
  transition: transform 300ms $extra-ease-out, opacity 300ms $extra-ease-out,
    visibility 0ms 300ms;

  &:after {
    content: '';
    position: absolute;
    bottom: 100%;
    right: $space-medium;
    width: 0;
    height: 0;
    transform: translate(-0.2rem);
    border: solid transparent;
    pointer-events: none;
    border-bottom-color: white;
    border-width: 8px;
    margin-left: -8px;
  }
}

.profile-link,
div.button.logout-button,
.assistance-button,
.private-button,
.logout-button,
.contractual-documents-button {
  display: flex;
  padding: $space-medium/2 $space-medium;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  border: none;
  border-radius: 0;
  color: $color-galaxy;
  font-size: 1.6rem;
  cursor: pointer;

  /deep/ svg {
    color: $color-daddy;
    margin-right: $space-small;
    width: 1.4rem;
  }

  /deep/ .small {
    font-size: 1.2rem;
    background-color: rgba(map_get($palette-primary, light), 0.16);
    color: map_get($palette-primary, main);
    border-radius: 6px;
    display: inline-block;
    padding: 0.3rem;
    font-weight: bold;
    margin-left: 0.3rem;
  }

  &:hover {
    background-color: $color-whisper;
    color: inherit;
  }
}

div.button.logout-button {
  color: $color-red;

  /deep/ svg {
    color: $color-red;
  }
}

.last-connection {
  padding: $space-small $space-medium 0;

  > *:first-child {
    border-top: 1px solid $color-ghost;
    padding-top: $space-small;
  }
}

li .button {
  /deep/ .md-ripple {
    justify-content: flex-start;
    padding-left: 0;
  }
}
</style>
